import { createFileRoute } from "@tanstack/react-router";

import GmpLambDataAnalysis from "~/pages/GmpLambDataAnalysis";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/gmp-lamb-data-analysis/")({
  staticData: ROUTE_STATIC.gmpLambDataAnalysis,
  component: GmpLambDataAnalysis,
});
